const AI_REVERSER_SERVICE = '/ai-reverser';
const AI_REVERSER_SERVICE_API = '/api';

export const AI_REVERSER_GATEWAY_BASE_URL = `${AI_REVERSER_SERVICE}${AI_REVERSER_SERVICE_API}`;
